import { ViewportRuler } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollingService {
  constructor(private readonly viewportRuler: ViewportRuler) {}

  scrollToTop(div: HTMLDivElement): void {
    setTimeout(() => {
      const elementRect = div.getBoundingClientRect();
      const viewportRect = this.viewportRuler.getViewportRect();

      const isInViewport =
        elementRect.top >= viewportRect.top &&
        elementRect.left >= viewportRect.left &&
        elementRect.bottom <= viewportRect.bottom &&
        elementRect.right <= viewportRect.right;

      if (!isInViewport) {
        div.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }, 0);
  }
}
